import React from "react";
import SidebarTenagaKesehatan from "../../components/SidebarTenagaKesehatan";
import TopbarTenagaKesehatan from "../../components/TopBarTenagaKesehatanLaporKendala";
import LaporkanKendalaTenagaKesehatan from "../../components/LaporkanKendalaTenagaKesehatan";
import "../../CSS/LaporKendalaTenagaKesehatan.css"; 

function HalamanLaporkanKendalaNakes() {
  return (
    <div className="laporkan-page">
      {/* Sidebar kiri */}
      <SidebarTenagaKesehatan />

      {/* Area kanan */}
      <div className="content">
        <TopbarTenagaKesehatan />

        {/* Konten utama */}
        <div className="main-content">
          <LaporkanKendalaTenagaKesehatan />
        </div>

        
      </div>
    </div>
  );
}

export default HalamanLaporkanKendalaNakes;
